const Component = () => import('./DietaryPreferenceNeeds');

export { Component };
